import loadModuleOnElement from "../../../utils/loadModuleOnElement";

const loader = () => import("./renderer");
const selector = ".rm-folders-button";

export default function loadFollowButton(context) {
    loadModuleOnElement(selector, loader, context);
    return context;
}
